import { render, staticRenderFns } from "./writeReport.vue?vue&type=template&id=5b038d53&scoped=true"
import script from "./writeReport.vue?vue&type=script&lang=js"
export * from "./writeReport.vue?vue&type=script&lang=js"
import style0 from "./writeReport.vue?vue&type=style&index=0&id=5b038d53&prod&rel=stylesheet%2Fscss&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b038d53",
  null
  
)

export default component.exports